import { ApiService, HttpMethod } from '../_common/api.service';
import { HttpClient } from '@angular/common/http';
import { I3AssetsDown } from './models/i3-assets-down.model';
import { I3AssetsMaintenanceDue } from './models/i3-assets-maintenance-due.model';
import { I3AssetsOperatingStatus } from './models/i3-assets-operating-status.model';
import { I3OpenWorkOrders } from './models/i3-open-work-orders.model';
import { Injectable } from '@angular/core';
import { Intelli360TokenInfo } from '../auth/models/Intelli360-token-info.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class Intelli360ApiService {

    private apiService: ApiService;

    // =========================================================================================================================================================
    // Ctor
    // =========================================================================================================================================================

    constructor(http: HttpClient) {
        this.apiService = new ApiService(http);
    }

    // =========================================================================================================================================================
    // Public Methods
    // =========================================================================================================================================================

    getAssetsDown(): Observable<I3AssetsDown> {
        return this.apiService.apiRequest<any>(Intelli360ApiService.assetsDownUrl, HttpMethod.Get)
            .pipe(map((response: I3AssetsDown) => new I3AssetsDown(response)));
    }

    getAssetsOperatingStatus(): Observable<I3AssetsOperatingStatus> {
        return this.apiService.apiRequest<any>(Intelli360ApiService.assetsOperatingStatusUrl, HttpMethod.Get)
            .pipe(map((response: I3AssetsOperatingStatus) => new I3AssetsOperatingStatus(response)));
    }

    getMaintenanceDueAssets(): Observable<I3AssetsMaintenanceDue> {
        return this.apiService.apiRequest<any>(Intelli360ApiService.maintenanceDueAssetsUrl, HttpMethod.Get)
            .pipe(map((response: I3AssetsMaintenanceDue) => new I3AssetsMaintenanceDue(response)));
    }

    getOpenWorkOrders(): Observable<I3OpenWorkOrders> {
        return this.apiService.apiRequest<any>(Intelli360ApiService.openWorkOrdersUrl, HttpMethod.Get)
            .pipe(map((response: I3OpenWorkOrders) => new I3OpenWorkOrders(response)));
    }

    getToken(): Observable<Intelli360TokenInfo> {
        return this.apiService.apiRequest<any>(Intelli360ApiService.tokenUrl, HttpMethod.Get)
            .pipe(map((response: Intelli360TokenInfo) => new Intelli360TokenInfo(response)));
    }

    // =========================================================================================================================================================
    // URLs
    // =========================================================================================================================================================

    private static get baseUrl(): string { return `${ApiService.baseApiUrl}intelli360`; }

    private static get assetsDownUrl(): string { return `${Intelli360ApiService.baseUrl}/assetsDown`; }

    private static get assetsOperatingStatusUrl(): string { return `${Intelli360ApiService.baseUrl}/assetsOperatingStatus`; }

    private static get maintenanceDueAssetsUrl(): string { return `${Intelli360ApiService.baseUrl}/maintenanceDueAssets`; }

    private static get openWorkOrdersUrl(): string { return `${Intelli360ApiService.baseUrl}/openWorkOrders`; }

    private static get tokenUrl(): string { return `${Intelli360ApiService.baseUrl}/token`; }

}
